import { useState, useEffect } from "react";
import { ReactComponent as CollapseIcon } from "../../../images/box-collapser.svg";
import { ReactComponent as ArrowIcon } from "../../../images/arrow-small-left.svg";
import { ReactComponent as DownloadIcon } from "../../../images/download.svg";
import Table from "components/elements/Table";
import Select from "components/elements/Select";
import Modal from "components/elements/Modal";
import utility from "core/Utils";
import dataProvider from "core/DataProvider";
import { useOutletContext } from "react-router-dom";
import IconInput from "components/elements/IconInput";
import "../../../styles/reports.css";
const { default: Header } = require("../Header");

const headerMap = {
  query_id: "Query ID",
  query_subject: "Query Subject",
  client_name: "Client Name",
  query_date: "Query Date",
  query_due_date: "Query Due Date",
  query_status: "Query Status",
  reported_by: "Reported By",
  delete: "Delete",
};

const QueryStatus = [
  { value: "New", label: "New" },
  { value: "InProcess", label: "In Process" },
  { value: "Resolved", label: "Resolved" },
];

const Support = () => {
  const token = useOutletContext();
  const { name, client_name } = token;
  const [data, setData] = useState([]);
  const [showColModal, setShowColModal] = useState(false);
  const [columns] = useState(utility.optionFromObject(headerMap));
  const [query_status, setSubGroup] = useState("");
  const [commonSegmentCollapsed, setCommonSegmentCollapsed] = useState(false);
  const [formCollapsed, setFormCollapsed] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState(
    utility.optionFromObject(headerMap)
  );
  const fetchData = async () => {
    let data = await dataProvider.network.get("query_support");
    setData(data.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const colModal = (
    <Modal onClose={() => setShowColModal(false)}>
      <h3>Select Columns</h3>
      <div className="full-row" style={{ width: "50vw", marginTop: "2rem" }}>
        <Select
          isMulti
          value={selectedColumns}
          options={columns}
          placeholder="Select columns to show"
          onChange={val => setSelectedColumns(val)}
        />
      </div>
    </Modal>
  );

  return (
    <div id="support" className="page">
      <Header user={name} client_name={client_name} title="Query Support" />
      <section>
        {showColModal && colModal}
        <div className="flex mtop">
          <div
            className={
              formCollapsed ? "form-wrapper collapsed" : "form-wrapper"
            }
          >
            <div
              className={
                commonSegmentCollapsed
                  ? "form-segment collapsed"
                  : "form-segment"
              }
            >
              <div
                className="segment-head"
                onClick={e =>
                  setCommonSegmentCollapsed(!commonSegmentCollapsed)
                }
              >
                <h6>Common</h6>
                <span>
                  <CollapseIcon />
                </span>
              </div>
              <div className="segment-body">
                <input
                  type="text"
                  name="search_query"
                  placeholder="Search Query"
                />
                <Select
                  options={QueryStatus}
                  value={query_status}
                  onChange={val => setSubGroup(val)}
                  placeholder="Query Status"
                />
              </div>
            </div>
            <button>Submit</button>
            <div
              className="collapser"
              onClick={e => setFormCollapsed(!formCollapsed)}
            >
              <ArrowIcon />
            </div>
          </div>
          <div className="results-wrapper flex-full">
            <div className="head flex flex-v-center">
              <h3>Results</h3>
              <div className="right">
                <div className="flex flex-v-center">
                  <div className="el">
                    <input
                      type="text"
                      readOnly
                      placeholder="Select Columns"
                      onClick={e => {
                        e.preventDefault();
                        setShowColModal(true);
                      }}
                    />
                  </div>
                  <div className="el">
                    <IconInput placeholder="Search" icon="search" />
                  </div>
                  <div className="el">
                    <Select
                      options={[
                        { value: "csv", label: "CSV" },
                        { value: "xlsx", label: "XLSX" },
                      ]}
                      placeholder="Format"
                    />
                  </div>
                  <div className="el icon">
                    <DownloadIcon />
                  </div>
                </div>
              </div>
            </div>
            <div className="results">
              <Table
                headers={utility.objectFromOptions(selectedColumns)}
                data={data}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Support;
